import React from 'react';
type CardProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'glass' | 'outline';
};
export function Card({
  children,
  className = '',
  variant = 'default'
}: CardProps) {
  const baseStyles = 'rounded-lg overflow-hidden';
  const variantStyles = {
    default: 'bg-white shadow-md',
    glass: 'bg-white/70 backdrop-blur-md shadow-lg',
    outline: 'border border-gray-200 bg-white'
  };
  return <div className={`${baseStyles} ${variantStyles[variant]} ${className}`} data-id="element-313">
      {children}
    </div>;
}
type CardHeaderProps = {
  children: React.ReactNode;
  className?: string;
};
export function CardHeader({
  children,
  className = ''
}: CardHeaderProps) {
  return <div className={`p-5 ${className}`} data-id="element-314">{children}</div>;
}
type CardBodyProps = {
  children: React.ReactNode;
  className?: string;
};
export function CardBody({
  children,
  className = ''
}: CardBodyProps) {
  return <div className={`p-5 pt-0 ${className}`} data-id="element-315">{children}</div>;
}
type CardFooterProps = {
  children: React.ReactNode;
  className?: string;
};
export function CardFooter({
  children,
  className = ''
}: CardFooterProps) {
  return <div className={`p-5 pt-0 flex items-center ${className}`} data-id="element-316">{children}</div>;
}